"use client";

import { useTranslations } from "next-intl";
import { CustomDialog } from "@/components/custom/dialog";

interface CancelConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function CancelConfirmationDialog({
  open,
  onClose,
  onConfirm,
}: CancelConfirmationDialogProps) {
  const t = useTranslations("dialogs.cancelInquiry");

  return (
    <CustomDialog
      open={open}
      onOpenChange={onClose}
      title={t("title")}
      description={t("description")}
      size="xs"
      stopInteractOutside={false}
      cancelText={t("cancelText")}
      okText={t("okText")}
      onOkClick={onConfirm}
      classNameTitle="text-xl"
    />
  );
}
